/**
 * Yardım al ekranının sınırları. Ana süreçteki kurallarla aynı olmalı
 * (src/services/featureRequestRules.ts) — `npm run test:prefs` ikisini
 * karşılaştırıyor. Buradakiler yalnızca arayüz içindir (sayaç, düğme); asıl
 * denetim ana süreçte ve veritabanında.
 */
export const FEATURE_REQUEST_MIN_LENGTH = 10;
export const FEATURE_REQUEST_MAX_LENGTH = 2000;

/** Veritabanındaki `char_length` gibi kod noktası sayar (emoji tek karakter). */
export function featureRequestLength(value: string): number {
  return [...value.trim()].length;
}
